import React from "react";
import Model from "../../common/Model";

const GoalForm = ({
  onClose,
  values,
  handleChange,
  handleBlur,
  editId,
  errors,
  touched,
  handleSubmit,
  loading,
}) => {
  
  return (
    <Model
      closeModal={onClose}
      title={`${editId ? "Edit" : "Add"} Goal`}
      isForm={true}
      loading={loading}
      handleSubmit={handleSubmit}
    >
      <div className="grid grid-cols-1 space-y-2 w-full">
        <label className="capitalize text-base font-medium text-foreground">
          Goal
        </label>
        <input
          className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary"
          type="text"
          placeholder="Enter Goal"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.name && errors.name && (
          <div className="text-red-500 text-sm">{errors.name}</div>
        )}
      </div>
    </Model>
  );
};

export default GoalForm;











